import React from 'react';
interface TestimonialsSectionProps {
  language: 'en' | 'es';
}
export function TestimonialsSection({
  language
}: TestimonialsSectionProps) {
  const testimonials = [{
    name: 'Carlos R.',
    roleEn: 'Business Owner',
    roleEs: 'Propietario de Negocio',
    textEn: 'MainPoint transformed our corporate tax strategy. The level of personalized attention and expertise feels like having a private family office.',
    textEs: 'MainPoint transformó nuestra estrategia fiscal corporativa. El nivel de atención personalizada y experiencia se siente como tener una oficina familiar privada.'
  }, {
    name: 'Elena M.',
    roleEn: 'Real Estate Investor',
    roleEs: 'Inversora de Bienes Raíces',
    textEn: 'Their insurance portfolio recommendations secured my assets perfectly. True luxury service with profound industry knowledge.',
    textEs: 'Sus recomendaciones de portafolio de seguros aseguraron mis activos perfectamente. Verdadero servicio de lujo con profundo conocimiento de la industria.'
  }];
  return <section id="testimonials" className="py-24 bg-luxury-bg relative overflow-hidden" data-id="element-293">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-gold-primary/5 rounded-full blur-[100px] -translate-y-1/2 -translate-x-1/2 pointer-events-none" data-id="element-294" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-295">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-296">
          <h2 className="font-sans text-sm font-bold text-gold-light tracking-[0.2em] uppercase mb-4" data-id="element-297">
            {language === 'en' ? 'Client Success' : 'Éxito del Cliente'}
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-warm-white mb-6" data-id="element-298">
            {language === 'en' ? 'A Legacy of Trust' : 'Un Legado de Confianza'}
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-299">
          {testimonials.map((testimonial, index) => <div key={index} className="relative bg-luxury-card rounded-xl p-8 sm:p-10 border border-gold-dark/10 pt-12" data-id="element-300">
              {/* Gold top border gradient */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-gold-primary to-transparent opacity-50 rounded-t-xl" data-id="element-301" />

              {/* Large Serif Quote */}
              <div className="absolute top-4 left-6 font-serif text-7xl text-gold-dark/20 leading-none select-none" data-id="element-302">
                "
              </div>

              <p className="font-serif text-xl sm:text-2xl text-warm-white/90 leading-relaxed mb-8 relative z-10 italic" data-id="element-303">
                "{language === 'en' ? testimonial.textEn : testimonial.textEs}"
              </p>

              <div className="flex items-center gap-4 border-t border-gold-dark/10 pt-6" data-id="element-304">
                <div className="w-12 h-12 rounded-full bg-luxury-alt border border-gold-primary/30 flex items-center justify-center" data-id="element-305">
                  <span className="font-serif text-gold-light font-bold text-lg" data-id="element-306">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-307">
                  <h4 className="font-sans font-bold text-warm-white tracking-wide" data-id="element-308">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gold-dark uppercase tracking-widest mt-1" data-id="element-309">
                    {language === 'en' ? testimonial.roleEn : testimonial.roleEs}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}